import { useEffect, useState } from "react";
import SvgIcon from "@mui/material/SvgIcon";

import "./style.scss";
import { ReactComponent as CopyIcon } from "../../../assets/copyIcon.svg";
import { fetchKnowledgeBaseInvites } from "../../../api/admin/knowledge-base/endpoints-referrers";
import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";
import { UserRole } from "../../../common/enums/user-role.enum";
import { Invite } from "../../../common/interfaces/admin/invite-interface";
import { LoaderView } from "../../../components/loader/loader.comp";
import Toast, { ToastContainer } from "../../../components/toast/toast.comp";
import HeaderLayout from "../../../components/layout/header-layout.comp";

const InviteCopyView = ({
    invite,
    handleInvite
}: {
    invite: string;
    handleInvite: (arg1: string) => void;
}) => {
    return (
        <div className="invite-link-item-content" onClick={() => handleInvite(invite)}>
            <span className="invite-link-item-content__text" title={invite}>
                {invite}
            </span>
            <SvgIcon
                className="invite-link-item-content__icon"
                component={CopyIcon}
                inheritViewBox
            />
        </div>
    );
};

const InviteCodesView = () => {
    const { user, knowledgeBases } = FirebaseAuthContainer.useContainer();
    const { showToast } = ToastContainer.useContainer();
    const [invites, setInvites] = useState<Invite[]>([]);
    const [adminInvite, setAdminInvite] = useState<string>("");
    const [assistantInvite, setAssistantInvite] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!user || !knowledgeBases.length) return;

        fetchKnowledgeBaseInvites(user.companyId, knowledgeBases[0].uid)
            .then(response => {
                const {
                    data: { items }
                } = response;
                setInvites(items);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [user, knowledgeBases]);

    useEffect(() => {
        if (!invites.length) return;

        const adminInvite = invites.find(invite => invite.role === UserRole.manager);
        const assistantInvite = invites.find(invite => invite.role === UserRole.user);
        if (adminInvite) {
            setAdminInvite(generateInviteLink(adminInvite.code, window.location.host));
        }
        if (assistantInvite) {
            setAssistantInvite(
                generateInviteLink(assistantInvite.code, window.location.host.replace("admin.", ""))
            );
        }
    }, [invites]);

    const generateInviteLink = (invite: string, host: string): string => {
        return `${window.location.protocol}//${host}/registration?invite=${invite}`;
    };

    const handleInviteClick = (invite: string) => {
        navigator.clipboard.writeText(invite);
        showToast("Invite link copied");
    };

    return (
        <HeaderLayout
            blurHeader={false}
            subheaderHeight={46}
            subheader={
                <div className="invite-links-header">
                    <div className="invite-links-header-title">
                        <span className="invite-links-header-title__text">Invite Links</span>
                    </div>
                </div>
            }
        >
            <div className="invite-links">
                <div className="invite-links-content">
                    <div className="invite-link-item">
                        <div className="invite-link-item-title">Admin Dashboard</div>
                        <InviteCopyView invite={adminInvite} handleInvite={handleInviteClick} />
                    </div>
                    <div className="invite-link-item">
                        <div className="invite-link-item-title">Assistant</div>
                        <InviteCopyView invite={assistantInvite} handleInvite={handleInviteClick} />
                    </div>
                </div>
            </div>
            <Toast />
            <LoaderView show={isLoading} className="invite-link-loader" />
        </HeaderLayout>
    );
};

export default InviteCodesView;
